import { type FormEvent, useState } from "react";

import { Button, Separator, Textarea } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { PickTranslation, SectionNotesTextAreaProps } from ".";

function pickTranslation({ isFocus }: PickTranslation) {
  if (isFocus) {
    return "note.placeholder_focus";
  }

  return "note.placeholder";
}

export function SectionNotesForm({
  onSubmit,
  onCancel = () => {},
  defaultValue = "",
  show = false,
  showSeparator = false,
}: SectionNotesTextAreaProps) {
  const [value, setValue] = useState(defaultValue);
  const [isFocus, setIsFocus] = useState(false);

  const hasNoValue = Boolean(!value);

  const { t } = useTranslation();

  const handleOnSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onSubmit?.(e);
    setIsFocus(false);
  };
  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };
  const handleOnFocus = () => {
    setIsFocus(true);
  };
  const handleOnBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if ((e.relatedTarget as HTMLElement)?.nodeName === "BUTTON") {
      return;
    }

    setIsFocus(false);
  };
  const handleOnCancel = () => {
    onCancel();
    setValue(defaultValue);
    setIsFocus(false);
  };

  if (!show) {
    return null;
  }

  return (
    <form onSubmit={handleOnSubmit} data-test="notes-form">
      <div className="flex flex-col gap-4">
        {showSeparator && show && <Separator />}
        <div className="flex flex-col gap-2">
          <Textarea
            data-test="notes-form-textarea"
            className="resize-y"
            name="content"
            value={value}
            onFocus={handleOnFocus}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            placeholder={t(pickTranslation({ isFocus }))}
          />
          {isFocus && (
            <div className="flex justify-end gap-2">
              <Button
                data-test="notes-form-cancel"
                onClick={handleOnCancel}
                size="lg"
                variant="ghost"
              >
                {t("cancel")}
              </Button>
              <Button
                variant="secondary"
                data-test="notes-form-done"
                size="lg"
                type="submit"
                disabled={hasNoValue}
              >
                {t("done")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </form>
  );
}
